import { scrollToElement } from "../utilities/scrollToElement";
import store from "@continente/vue/components/store";
import { PAYMENT_METHOD_PAYPAL } from "../utilities/constants";
import { updateCartSummaryModalClass } from "../components/cartUtil";
import { removeCurrencyFromStringAndConverToNumber } from "../components/convertUtils";
import { loadingDotsActivation } from "../components/pageLoading";
import { isNewAddressInputSelected } from "../checkout/shippingCTUtils";
import { getCookie } from "../components/cookie";

const debounce = require("lodash/debounce");

const $cache = {
    mainContent: $(".checkout-steps--wrapper")
};

const regex = require("../utilities/regex");

/**
 * Book delivery slot API call
 */
const bookDeliverySlot = async (shipmentID, shippingSlotSchedulerId, shippingSlotOperatorId, shippingListId, unbookDeliverySlot) => {
    const bookDeliverySlotURL = $(".js-book-delivery-slots").attr("data-url");

    const data = {
        shipmentID: shipmentID,
        shippingSlotSchedulerId: shippingSlotSchedulerId,
        shippingSlotOperatorId: shippingSlotOperatorId,
        shippingListId: shippingListId,
        unbookDeliverySlot: unbookDeliverySlot
    };

    $.spinner().start();

    const result = await $.ajax({
        url: bookDeliverySlotURL,
        method: "POST",
        dataType: "json",
        data: data
    });

    if (!result || result.error) {
        const $deliverySlotsServiceErrorModal = $("#service-error-delivery-slots");

        $cache.mainContent.spinner().stop();
        $deliverySlotsServiceErrorModal.modal("show");
        updateCartSummaryModalClass(true);
        return;
    }

    if (result.orderShippingTotal) {
        let checkoutOrderSummaryInfo = store.getters.getOrderSummaryInfo();
        let checkoutShipmentInformation = store.getters.getShipmentInformation();
        let selectedShippingMethods = [];

        checkoutOrderSummaryInfo.shipping.forEach(element => {
            if (element.externalShipmentID == shipmentID) {
                element.selectedShippingMethod.shippingCost = result.isShippingPromotionWithCoupon ? result.shipmentOriginalPrice : result.shipmentTotalPrice;
                element.selectedShippingMethod.shipmentOriginalPrice = result.shipmentOriginalPrice;
                checkoutShipmentInformation.forEach(shipment => {
                    if (shipment.shipmentID == shipmentID) {
                        shipment.originalPrice = result.shipmentOriginalPrice;
                        shipment.discountPrice = result.shipmentTotalPrice;
                    }
                });
            }
            selectedShippingMethods.push(element.selectedShippingMethod.description);
        });

        checkoutOrderSummaryInfo.totals.grandTotal = result.totalGrossPrice;

        checkoutOrderSummaryInfo.totals.couponLevelDiscountTotal = result.couponLevelDiscountTotal;

        checkoutOrderSummaryInfo.totalAcumulatedDiscount = result.acumulaTotal;

        store.commit("setOrderSummaryInfo", checkoutOrderSummaryInfo);
        store.commit("setShipmentInformation", checkoutShipmentInformation);

        const previouslyBookedSlots = document.querySelector("[data-previously-booked-delivery-slots]");
        if (previouslyBookedSlots) {
            const activeShipmentIndex = shipmentID.match(/_(\d+)$/)[1].replace(/^0+/, "") - 1;
            var previouslyBookedSlotsObj = previouslyBookedSlots.dataset.previouslyBookedDeliverySlots.split(",");
            previouslyBookedSlotsObj[activeShipmentIndex] = shippingSlotSchedulerId;
            previouslyBookedSlots.setAttribute("data-previously-booked-delivery-slots", previouslyBookedSlotsObj.join(","));
        }

        let $checkoutAcumula = $(".js-acumula-area");
        if ($checkoutAcumula.length > 0) {
            let $acumulaValueTextContainer = $checkoutAcumula.find(".total-discount-value");
            let convertedAcumulaAmount = removeCurrencyFromStringAndConverToNumber(store.getters.getOrderSummaryInfo().totalAcumulatedDiscount);
            if (convertedAcumulaAmount && convertedAcumulaAmount != "0,00" && convertedAcumulaAmount != "NaN" && convertedAcumulaAmount != "N/A") {
                $acumulaValueTextContainer.empty().append("€" + convertedAcumulaAmount);
                if ($checkoutAcumula.hasClass("d-none")) {
                    $checkoutAcumula.removeClass("d-none");
                }
            } else {
                $checkoutAcumula.addClass("d-none");
            }
        }
    }

    if (result.pageDataLayer) {
        $("input[name='checkoutDataLayer']").val(JSON.stringify(result.pageDataLayer));
    }

    $cache.mainContent.spinner().stop();

    return result;
};

/**
 * Set split shipping summary maximum height, for mobile breakpoint
 */
const setSplitShippingSummaryMaxHeight = debounce(() => {
    const splitShippingSummaryWrapper = document.querySelector(".split-shipping-summary-wrapper");

    if (!splitShippingSummaryWrapper || !window.mqRespond.status.mobile) { return; }

    const splitShippingSummaryDetails = document.querySelector(".ct-cart--summary-details");
    const summaryWrapper = document.querySelector(".ct-cart--summary-wrapper");
    const headerStickyContainers = document.querySelectorAll(".sticky-container");
    const entregaZeroMobile = document.querySelector(".ct-cart--mobile-entrega-zero");
    let summaryDetailsMaxHeight = 0;

    splitShippingSummaryDetails.style.removeProperty("maxHeight");
    splitShippingSummaryDetails.style.removeProperty("overflow");

    headerStickyContainers.forEach(elem => summaryDetailsMaxHeight += elem.offsetHeight);
    summaryDetailsMaxHeight += summaryWrapper.offsetHeight + parseInt(window.getComputedStyle(summaryWrapper).getPropertyValue("margin-top"), 10);
    summaryDetailsMaxHeight += entregaZeroMobile ? entregaZeroMobile.offsetHeight : 0;

    splitShippingSummaryDetails.style.overflow = "auto";
}, 200);

/**
 * Scroll to specific delivery slot
 * @param {String} shipmentID - Shipment ID
 */
const scrollToDeliverySlot = (shipmentID) => {
    const $checkoutNoDeliveryModal = $("#checkout-no-delivery-modal");
    $checkoutNoDeliveryModal.modal("show");
    updateCartSummaryModalClass(true);

    $checkoutNoDeliveryModal.off("hide.bs.modal").on("hide.bs.modal", debounce(() => {
        scrollToElement($(`.shipping-delivery-slot[data-shipment-id="${shipmentID}"]`), 1000);
    }, 200));
};

/**
 * Checks if the specific delivery schedule is the last one
 * @param {Element} slickContainer - Element with the slick slider attatched
 */
const isLastShippingSchedule = (slickContainer) => {
    if (!slickContainer.hasClass("slick-initialized")) { return; }

    const currentSlideIndex = slickContainer.slick("slickCurrentSlide");
    const totalSlides = slickContainer.slick("getSlick").slideCount;
    const isLastSlide = currentSlideIndex === (totalSlides - 1);

    return isLastSlide;
};

/**
 * Verifies if no delivery slot selected or they are not available.
 */
const checkIfNoDeliverySlotSelectedNorAvailable = () => {
    const $checkoutNoDeliveryModal = $("#checkout-no-delivery-modal");
    let isModalDisplayed = false;

    if ($(".js-delivery-slots-wrapper").length) {
        $checkoutNoDeliveryModal.modal("show");
        updateCartSummaryModalClass(true);
        isModalDisplayed = true;
    }

    return isModalDisplayed;
};

/**
 * Verifies if the tax number and company name are filled when the client represents a company
 */
const checkCompanyRequiredFields = () => {
    const isCompany = document.getElementById("isCompany")?.value == "true";
    if (!isCompany) return { taxNumberValid: true, companyNameValid: true };

    const $taxNumberValue = $(".js-taxnumber-value");
    const $companyNameValue = $(".js-companyname-value");

    const taxNumber = $taxNumberValue?.text()?.trim();
    const companyName = $companyNameValue?.val()?.trim();

    return { taxNumberValid: taxNumber !== "", companyNameValid: companyName !== "" };
};

/**
 * Display error modal if order submit fails with a retry button
 */
const displayErrorModalIfOrderSubmitFails = () => {
    const $checkoutNoDeliveryModal = $("#service-error-order-submit");
    const $redirectErrorBooleanElement = $("[data-redirect-error]");

    if (!$redirectErrorBooleanElement.length || !$checkoutNoDeliveryModal.length)  { return; }

    if ($redirectErrorBooleanElement.attr("data-redirect-error") == "true") {
        $checkoutNoDeliveryModal.modal("show");
        updateCartSummaryModalClass(true);
    }
};

/**
 * Scroll to payment methods
 */
const scrollToPaymentMethods = () => {
    const $paymentMethodsMethods = $("#step-payment-methods");
    const selectedPaymentMethod = document.querySelector("#selectedPaymentMethod");
    const selectedPaymentMethodIsPayPal = selectedPaymentMethod.value == PAYMENT_METHOD_PAYPAL;
    const isPaymentMethodSelected = $(".js-payment-method-selection input:checked").length;
    const isEveryScheduleSelected = [...document.querySelectorAll(".step-type--schedule")].every(schedule => schedule.classList.contains("js-step-filled"));
    const isMBWayInvalid = $(".ct-payment--mbway-phone-input-prefix").hasClass("is-invalid");

    if ($paymentMethodsMethods.hasClass("js-step-filled") && 
        !selectedPaymentMethodIsPayPal && 
        isPaymentMethodSelected && 
        !isMBWayInvalid || 
        !isEveryScheduleSelected) {
        loadingDotsActivation(".submit-payment");
        return;
    }

    const $errorPaymentModal = selectedPaymentMethodIsPayPal ? $("#checkout-place-order-with-paypal-info") : $("#checkout-no-payment-method-modal");

    $errorPaymentModal.modal("show");
    updateCartSummaryModalClass(true);
    $errorPaymentModal.off("hide.bs.modal").on("hide.bs.modal", debounce(() => {
        scrollToElement($paymentMethodsMethods, 1000);
    }, 200));
};

/**
 * Scroll to billing information area and show the correct modal based on the missing field
 */
const scrollToCompanyRequiredFields = (missingTaxNumber, missingCompanyName) => {
    let $modalToShow = null;

    if (missingTaxNumber) {
        $modalToShow = $("#checkout-no-tax-number-modal");
    } else if (missingCompanyName) {
        $modalToShow = $("#checkout-no-company-name-modal");
    }

    if ($modalToShow) {
        $modalToShow.modal("show");
        updateCartSummaryModalClass(true);

        $modalToShow.off("hide.bs.modal").on("hide.bs.modal", debounce(() => {
            scrollToElement($("#nostep-billing"), 1000);
        }, 200));
    }
};

/**
 * Check split shipment service state
 */
const checkSplitShipmentServiceState = () => {
    const basketSplitError = document.querySelector("[data-basket-splits-error]")?.dataset.basketSplitsError;

    if (!basketSplitError || basketSplitError == "null") {
        return false;
    }

    return basketSplitError;
};

/**
 * Display split shipment error modal
 */
const displaySplitShipmentModalError = () => {
    const isSplitShipmentError = checkSplitShipmentServiceState();

    if (!isSplitShipmentError) { return; }

    const $splitShipmentErrorModal = $("#split-shipment-error-modal");

    $splitShipmentErrorModal.modal("show");
    updateCartSummaryModalClass(true);
};

/**
 * clears form(street field) in case of presence of tags with scripts
 * @param {Object} response
 */
const clearFormData = response => {
    let auxVariable = "";

    // clear street
    if (Object.hasOwn(response, "street1")) {
        auxVariable = response.street1 || "";
        response.street1 = auxVariable.replace(regex.values.XSSRegex, "");
    }

    return response;
};

/**
 * @function
 * @description -  * Events to WARN customers about potential loss of selected shipping deliveries when leaving the checkout.
 *
 * This function displays a warning pop-up if the customer close the browser or click the back button,
 * informing them that they may lose their previously selected shipping deliveries.
 *
 * Note: The warning pop-up will not appear when navigating between checkout steps, except when going back to the first step,
 * which might result in a loss of delivery slots (if users changes product quantity or deletes a product for example)
 */
const stepExitCheckoutModal = () => {
    $(".after-stage > .nav-link").off("click").on("click", (e) => {
        const $this = $(e.currentTarget);
        const $parent = $this.closest(".cart-title");

        if (!$parent.length) {
            window.onbeforeunload = null;
        }
    });

    const shippingExitModal = $("#shipping-exit-modal");

    // Handles all anchor tags (<a>) clicks on checkout pages
    $("a").on("click", function (e) {
        if ($(this).is("[no-redirect-validation]")) {
            return;
        }

        const linkHref = $(this).attr("href");
        if (linkHref && linkHref.indexOf(location.hostname) !== -1 || $(this).closest(".html-slot-container").length > 0) {
            $.spinner().stop();
            e.preventDefault();
            shippingExitModal.modal("show");

            $(".js-shipping-exit-button").off("click").on("click", () => {
                if (getCookie("mobileAppData")) {
                    $.spinner().start();
                }

                window.onbeforeunload = null;
                window.location.href = linkHref;
            });
        }
    });

    window.onbeforeunload = function (e) {
        // Only trigger if user is navigating away from the site
        e.preventDefault();
        var navigationType = performance.getEntriesByType("navigation")[0].type;
        if (navigationType !== 1) {
            var confirmationMessage = "Voltar atrás poderá resultar na perda dos horários previamente selecionados.";
            e.returnValue = confirmationMessage;
            return confirmationMessage;
        }
    };
};

/**
* Updates the index of pagination for the slider (e.g: Current active: slide index X out of Y maximum slides)
* @param {object} element - Initialized slick slider element
* @param {bool} canProceedToNextSlide - check if user can proceed to the next slide
*/
const updateShippingPaginationBasedOnIndex = (slick) => {
    if (!slick) { return; }

    const noOfTotalSlides = slick.slideCount;

    if (noOfTotalSlides) {
        const currentActiveSlide = slick.currentSlide + 1;
        const $slideIndexStatus = $(".js-current-slide-status");
        const indexResource = $slideIndexStatus.data("resource");
        const updatedText = indexResource.replace("currentSlide", currentActiveSlide);
        $slideIndexStatus.text(updatedText);

        const $proceedToPaymentBtn = $(".submit-shipping");
        const $proceedToPaymentBtnMessage = $proceedToPaymentBtn.find(".checkout-continue--msg");
        const isLastSlide = currentActiveSlide === noOfTotalSlides;
        
        if (isLastSlide) {
            const checkoutPaymentUrl = $proceedToPaymentBtn.data("summary-continue-btn-label");
            $proceedToPaymentBtnMessage.text(checkoutPaymentUrl);
        } else {
            const summaryStepsTextTracker = $proceedToPaymentBtn.data("summary-steps-text-tracker");
            const updatedTextForCheckoutPaymentBtn = summaryStepsTextTracker.replace("{0}", currentActiveSlide + 1) + noOfTotalSlides;
            $proceedToPaymentBtnMessage.text(updatedTextForCheckoutPaymentBtn);
        }
    }
};

/**
* Updates the selection of shipping slot for the slider
* @param {object} element - Initialized slick slider element
*/
const selectShippingScheduleBasedOnIndex = (element) => {
    const currentShipping = element || document.querySelector(".js-shipment-step");

    if (!currentShipping) return;

    const isNonSchedule = currentShipping.querySelector(".delivery-schedule-date")?.classList.contains("non-scheduled-delivery");

    const deliveryScheduleFirstItem = isNonSchedule
        ? currentShipping.querySelector(".delivery-schedule-date-item input")
        : currentShipping.querySelector(".delivery-schedule-interval-item input");

    const previouslyBookedSlots = document
        .querySelector("[data-previously-booked-delivery-slots]")
        ?.dataset.previouslyBookedDeliverySlots.split(",");

    const isSlotAlreadySelected = () => {
        return isNonSchedule ? currentShipping.querySelector(".delivery-schedule-date-item.selected-non-scheduled") : currentShipping.querySelector(".delivery-schedule-interval-item .interval-item-wrapper.selected");
    };

    const isAddressSelected = () => {
        const shipmentId = currentShipping.querySelector(".shipping-delivery-slot")?.dataset.shipmentId;
        const currentShipmentContainer = document.querySelector(`.shipping-delivery-slot[data-shipment-id="${shipmentId}"]`);
        const currentShipmentShippingSection = currentShipmentContainer.closest(".step--wrapper")?.previousElementSibling;
        return $(currentShipmentShippingSection?.querySelector(".pwc-form-check-input:checked"));
    };

    const shouldClickFirstItem = () => {
        const isDisableAutomaticSlotting = document.querySelector("#disable-automatic-slotting")?.value === "true";
        return !isDisableAutomaticSlotting && deliveryScheduleFirstItem && !isSlotAlreadySelected();
    };

    const handlePreviouslyBookedSlots = (isNonSchedule) => {
        let isSlotPreviouslySelected = false;
        const selectedAddress = isAddressSelected();

        if (isNonSchedule) {
            const nonScheduledShippingSlot = currentShipping.querySelector(".delivery-schedule-date-item [data-shipping-slot-scheduler-id]");
            if (
                previouslyBookedSlots.includes(nonScheduledShippingSlot.dataset.shippingSlotSchedulerId) &&
                !nonScheduledShippingSlot.parentElement.classList.contains("selected-non-scheduled") &&
                selectedAddress.length > 0 &&
                !isNewAddressInputSelected(selectedAddress)
            ) {
                isSlotPreviouslySelected = true;
                nonScheduledShippingSlot.click();
            }
        } else {
            currentShipping.querySelectorAll(".delivery-schedule-interval-list [data-shipping-slot-scheduler-id]").forEach((elem, index) => {
        
                if (
                    previouslyBookedSlots.includes(elem.dataset.shippingSlotSchedulerId) &&
                    !elem.parentElement.classList.contains("selected") &&
                    selectedAddress.length > 0 &&
                    !isNewAddressInputSelected(selectedAddress)
                ) {
                    isSlotPreviouslySelected = true;
                    elem.click();
                    if (index >= 2) {
                        currentShipping.querySelector(".toggle-interval-list")?.click();
                    }
                }
            });
        }
    
        return isSlotPreviouslySelected;
    };

    if (!previouslyBookedSlots || previouslyBookedSlots[0] === "null") {
        if (shouldClickFirstItem()) {
            deliveryScheduleFirstItem?.click();
        }
    } else {
        const isSlotPreviouslySelected = handlePreviouslyBookedSlots(isNonSchedule);
    
        if (!isSlotPreviouslySelected && shouldClickFirstItem()) {
            deliveryScheduleFirstItem?.click();
        }
    }
};

export {
    bookDeliverySlot,
    setSplitShippingSummaryMaxHeight,
    scrollToDeliverySlot,
    isLastShippingSchedule,
    scrollToPaymentMethods,
    scrollToCompanyRequiredFields,
    checkIfNoDeliverySlotSelectedNorAvailable,
    checkCompanyRequiredFields,
    displayErrorModalIfOrderSubmitFails,
    displaySplitShipmentModalError,
    clearFormData,
    stepExitCheckoutModal,
    updateShippingPaginationBasedOnIndex,
    selectShippingScheduleBasedOnIndex
};
